export const ICON_NAV_LINK_TYPES = {
	BUTTON: 'BUTTON',
	LINK: 'LINK',
	STATIC: 'STATIC'
} as const;
